import { ServerSideRowModelModule } from "ag-grid-enterprise";
import { ModuleRegistry } from '@ag-grid-community/core';
import { observer } from "mobx-react";
import useStore from "../../../../store";
import { ServerGridConfig } from "../../../../config/GridConfig";
import { AgGridReact } from 'ag-grid-react';
import Message from '../../../../config/Message';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const ListComponent = observer((props) => {
	ModuleRegistry.registerModules([ServerSideRowModelModule]);
	dayjs.extend(utc);
	dayjs.extend(timezone);

	const { ENQUIRY } = useStore();
	const { openEditModal, openDeleteModal } = props;

	const ActionRenderer = (props) => {
			return (
				<div className="action-column">
					<Button
						type="text"
						title={'Edit'}
						className="editIcon"
						onClick={() => {
							ENQUIRY.ReadEnquiry(props.data.id);
							openEditModal();
						}}
					>
						<FontAwesomeIcon icon={faPencilAlt} />
					</Button>
					<Button
						type="text"
						title={'Delete'}
						className="deleteIcon"
						onClick={() => {
							openDeleteModal(props.data);
						}}
					>
						<FontAwesomeIcon icon={faTrashAlt} color={'red'} />
					</Button>
				</div>
			);
		};

	const colDefs = [
		{
			headerName: 'Date',
			field: 'createdOn',
			minWidth: 110,
			sort: 'desc',
			valueFormatter: ({ value }) => {
				return value
				? dayjs.utc(value).tz('Asia/Kolkata').format('DD/MM/YYYY') : '';
			},
		},
		{
			headerName: 'Type',
			field: 'enquiryType',
			minWidth: 100,
		},
		{
			headerName: 'Name',
			field: 'name',
			minWidth: 150,
		},
		{
			headerName: 'Mobile No',
			field: 'mobileNumber',
			minWidth: 110,
		},
		{
			headerName: 'Email',
			field: 'email',
			minWidth: 250,
		},
		{
			headerName: 'City',
			field: 'city',
			minWidth: 150,
		},
		{
			headerName: 'Property Name',
			field: 'propertyName',
			minWidth: 150,
		},
		{
			headerName: 'Description',
			field: 'description',
			minWidth: 170,
			tooltipField: 'description',
		},
		{
			headerName: 'Preferred date',
			field: 'preferredDate',
			minWidth: 110,
			valueFormatter: ({ value }) => {
				return value
					? dayjs(value).format('DD/MM/YYYY') : '';
			},
		},
		{
			headerName: 'Status',
			field: 'enquiryStatus',
			minWidth: 100,
			tooltipField: 'enquiryStatus',
		},
		{
			headerName: 'Actions',
			field: 'actions',
			cellRenderer: 'ActionRenderer',
			pinned: 'right',
			sortable: false,
			filter: false,
			minWidth: 120,
			width: 120,
		},


	];
	return (
		<div
			className="ag-theme-quartz"
			style={{ height: 'calc(100vh - 160px)' }}
		>
			<AgGridReact
				onGridReady={ENQUIRY.setupGrid}
				headerHeight={35}
				columnDefs={colDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={Message().noRecord}
				gridOptions={ServerGridConfig.options}
				defaultColDef={ServerGridConfig.defaultColDef}
				components={{
					ActionRenderer,
					openEditModal,
					openDeleteModal,
				}}
			/>
		</div>
	);
})

export default ListComponent;